import { combineReducers } from "redux";
import { plateAddressesReducer } from "./PlateAddressReducer";
import { moduleStatesReducer } from "./ModuleStateReducer";
import { temperatureReducer } from "./TemperatureReducer";
import { imagingScheduleReducer } from "./ImagingScheduleReducer";
import { imagerCapabilitiesReducer } from "./ImagerCapabilitiesReducer";
import { modulesReducer } from "./ModuleReducer";
import { liveImageReducer } from "./LiveImageReducer";
import { PsrCameraLiveImageReducer } from "./PsrCameraLiveImageReducer";
import { diagnosticReducer } from "./DiagnosticReducer";
import { notificationsReducer } from "./NotificationReducer";
import { modulesCapabilitiesReducer } from "./ModuleCapabilitiesReducer";
import { useSelector, TypedUseSelectorHook } from "react-redux";
import { storageConfigsReducer } from "./StorageConfigReducer";
import { localUserReducer } from "./LocalUserReducer";
import { initialConfigReducer } from "./InitialConfigurationReducer";
import { modalNotificationsReducer } from "./ModalNotificationReducer";
import { authenticationSettingReducer } from "./AuthenticationSettingReducer";
import { licenseReducer } from "./LicenseReducer";

const rootReducer = combineReducers({
  moduleStore: modulesReducer,
  plateAddressStore: plateAddressesReducer,
  moduleStateStore: moduleStatesReducer,
  temperatureStore: temperatureReducer,
  imagingScheduleStore: imagingScheduleReducer,
  imagerCapabilityStore: imagerCapabilitiesReducer,
  liveImageStore: liveImageReducer,
  psrCameraLiveImageStore: PsrCameraLiveImageReducer,
  diagnosticStore: diagnosticReducer,
  notificationsStore: notificationsReducer,
  modalNotificationsStore: modalNotificationsReducer,
  modulesCapabilitiesStore: modulesCapabilitiesReducer,
  storageConfigsStore: storageConfigsReducer,
  localUserStore: localUserReducer,
  authenticationSettingStore: authenticationSettingReducer,
  initialConfiguration: initialConfigReducer,
  licenseStore: licenseReducer,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
